module.exports = __webpack_public_path__ + "static/media/batteryIcon.bc39adcf.svg";